import React from 'react'
import { Select, MenuItem } from '@mui/material'
import { getOperatorsForType } from '../../../utils/filters/filterOperators'

const FilterOperatorSelectMUI = ({ fieldType, value, onChange }) => {
    const operators = getOperatorsForType(fieldType)

    return (
        <Select
            size="small"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            fullWidth
            sx={{
                fontSize: '0.8rem',
                '& .MuiSelect-select': {
                    padding: '4px 8px',
                },
            }}
        >
            {operators.map((op) => (
                <MenuItem key={op.key} value={op.key} sx={{ fontSize: '0.8rem' }}>
                    {op.label}
                </MenuItem>
            ))}
        </Select>
    )
}

export default FilterOperatorSelectMUI
